import {
  checkSummitIClassValidation,
  checkIClassValidation
} from '../AllocationTable/utils';

export const displayIClassFilter = (amount, rewardsAvailable) => {
  if (rewardsAvailable?.iClassFunds) {
    return !checkSummitIClassValidation(amount);
  }
  return amount && !checkIClassValidation(amount);
};
